import script from "./TeacherDetailsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./TeacherDetailsModal.vue?vue&type=script&setup=true&lang=js"

import "./TeacherDetailsModal.vue?vue&type=style&index=0&id=84971a9c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84971a9c"]])

export default __exports__